module.exports = __webpack_public_path__ + "static/indigo-logo-b0a4c2504483ec9140a807aac15d3d1c.png";